<template>
  <button
    class="selected-number-button"
    :class="{ 'selected-number-button selected': selected }"
    @click="onClick(phoneNumber)"
  >
    {{ number }}
  </button>
</template>

<script>
export default {
  name: 'SelectedNumber',
  props: {
    selected: Boolean,
    number: String,
    phoneNumber: String,
    onClick: Function
  }
};
</script>

<style scoped lang="scss">
.selected-number-button {
  width: 234px;
  height: 70px;
  background-color: #ffffff;
  border: 1px solid rgba(223, 225, 229, 0.7);
  box-sizing: border-box;
  border-radius: 4px;
  outline: none;
  font-weight: 500;
  font-size: 24px;
  line-height: 35px;
  letter-spacing: -0.04em;
  color: $colorPlaceholder;
  cursor: pointer;

  &.selected {
    color: #ffffff;
    background-color: $colorGreen;
  }

  &:hover {
    color: #ffffff;
    background-color: $colorGreen;
  }

  @media (min-width: 320px) and (max-width: 480px) {
    width: 100%;
    height: 50px;
    font-weight: 500;
    font-size: 16px;
    line-height: 26px;
    letter-spacing: -0.04em;
  }
}
</style>
